/* ==========================================================================
   RYNOR — BLOG (v2)                                          assets/rynor-blog.js
   Loaded by sections/rynor-article.liquid (a blog post) and sections/rynor-blog.liquid. Small jobs:
     1. COPY LINK in the share row: copies the post's link, says "Link copied" for 2 seconds.
     2. MORE STORIES slider: drag it sideways with the mouse on desktop.
        (Phones, iPads and trackpads already swipe it natively.)
     3. A "Full screen" photo ends at the bottom of the screen, so its title and date show
        without scrolling (the announcement bar above it would push them down).
   One listener each on the page, so it keeps working when the theme editor reloads a section.
   The words come from the Liquid (data-* attributes), never from this file.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__rynorBlog) return;
  window.__rynorBlog = true;

  /* ---------- 1. Copy link ---------- */
  function copyLink(button) {
    var url = button.getAttribute('data-url') || window.location.href;
    var label = button.querySelector('[data-rb-copy-label]') || button;
    var original = button.getAttribute('data-label') || label.textContent;
    var done = button.getAttribute('data-done') || original;

    function finished() {
      label.textContent = done;
      button.classList.add('is-done');
      window.clearTimeout(button.__rbTimer);
      button.__rbTimer = window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-done');
      }, 2000);
    }

    function oldWay() {
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.top = '0';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try { if (document.execCommand('copy')) finished(); } catch (e) { /* nothing else to try */ }
      document.body.removeChild(field);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(finished, oldWay);
    } else {
      oldWay();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var copy = target && target.closest ? target.closest('[data-rb-copy]') : null;
    if (copy) {
      event.preventDefault();
      copyLink(copy);
    }
  });

  /* ---------- 2. Drag the MORE STORIES slider with the mouse ---------- */
  var drag = null;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var row = event.target && event.target.closest ? event.target.closest('[data-rb-slider]') : null;
    if (!row || row.scrollWidth <= row.clientWidth + 1) return;
    drag = { row: row, x: event.clientX, left: row.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    if (!(event.buttons & 1)) { endDrag(); return; }   /* button let go outside the window */
    var dx = event.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 6) {
      drag.moved = true;
      drag.row.classList.add('is-dragging');
      var picked = window.getSelection ? window.getSelection() : null;
      if (picked && picked.removeAllRanges) picked.removeAllRanges();
    }
    if (drag.moved) {
      drag.row.scrollLeft = drag.left - dx;
      event.preventDefault();
    }
  });

  function endDrag() {
    if (!drag) return;
    var done = drag;
    drag = null;
    if (!done.moved) return;
    done.row.classList.remove('is-dragging');
    /* a drag must not open the card it ended on */
    var stop = function (event) { event.preventDefault(); event.stopPropagation(); };
    done.row.addEventListener('click', stop, true);
    window.setTimeout(function () { done.row.removeEventListener('click', stop, true); }, 0);
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  /* no "ghost image" of a photo or link while dragging */
  document.addEventListener('dragstart', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-rb-slider]')) event.preventDefault();
  });

  /* ---------- 3. Full-screen photos end exactly at the bottom of the screen ---------- */
  /* The announcement bar sits above the photo, so a photo as tall as the screen would push
     the title and date below the fold. Tell the CSS how much space is above the photo. */
  function fitHeroes() {
    var heroes = document.querySelectorAll('.ra-hero--full, .rb-hero--full');
    for (var i = 0; i < heroes.length; i++) {
      var above = heroes[i].getBoundingClientRect().top + (window.pageYOffset || 0);
      heroes[i].style.setProperty('--rb-above', Math.max(0, Math.round(above)) + 'px');
    }
  }
  fitHeroes();
  window.addEventListener('load', fitHeroes);
  window.addEventListener('resize', fitHeroes);
  document.addEventListener('shopify:section:load', fitHeroes);
})();
